import { Account } from './account.model';

export class AuthData {
    username: string;
    token: string;
    accountID: string;
    accounts: Account[]
}